import { GridContainer, GridItem, GridRow } from '@tvg/fuse/grid';
import React from 'react';
import { BottomRow } from './BottomRow';
import styles from './CardGrid.module.css';
import Pagination from './Pagination/Pagination';
import { ProductCardList } from './ProductCardList';
import { TopRow } from './TopRow';

export function CardGrid() {
  return (
    <GridContainer className={styles.cardGrid}>
      <TopRow />

      <ProductCardList />

      <BottomRow />

      <GridRow className="row">
        <GridItem xxs={12} className={styles.cardGrid__paginationContainer}>
          <Pagination />
        </GridItem>
      </GridRow>
    </GridContainer>
  );
}
